import Header from '../../components/Header';
import Footer from '../../components/Footer';
import MobileEmergencyBar from '../../components/MobileEmergencyBar';
import ServiceHero from './components/ServiceHero';
import ServicesGrid from './components/ServicesGrid';
import SafetyChecklist from './components/SafetyChecklist';
import FaultDiagnosisFlow from './components/FaultDiagnosisFlow';
import WarningSignsGuide from './components/WarningSignsGuide';
import EmergencyProcedures from './components/EmergencyProcedures';
import TestimonialsSection from './components/TestimonialsSection';
import BeforeAfterGallery from './components/BeforeAfterGallery';
import ServiceAreaMap from './components/ServiceAreaMap';
import CTASection from './components/CTASection';

const ElectricalServices = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      
      <main className="flex-1 pt-16">
        <ServiceHero />
        <ServicesGrid />
        <SafetyChecklist />
        <FaultDiagnosisFlow />
        <WarningSignsGuide />
        <EmergencyProcedures />
        <TestimonialsSection />
        <BeforeAfterGallery />
        <ServiceAreaMap />
        <CTASection />
      </main>

      <Footer />
      <MobileEmergencyBar />
    </div>
  );
};

export default ElectricalServices;